export const MOD_SORT_OPTIONS = [
  {
    name: 'sort_recently_added',
    key: 'date_live',
    direction: 'desc',
  },
  {
    name: 'sort_last_updated',
    key: 'date_updated',
    direction: 'desc',
  },
  {
    name: 'sort_trending',
    key: 'downloads_today',
    alias: 'stats.downloads_today',
    direction: 'desc',
    default: true,
  },
  {
    name: 'sort_highest_rated',
    key: 'ratings_weighted_aggregate',
    alias: 'stats.ratings_weighted_aggregate',
    direction: 'desc',
  },
  {
    name: 'sort_most_popular',
    key: 'downloads_total',
    alias: 'stats.downloads_total',
    direction: 'desc',
  },
  {
    name: 'sort_most_subscribers',
    key: 'subscribers_total',
    alias: 'stats.subscribers_total',
    direction: 'desc',
  },
  {
    name: 'sort_alphabetical',
    key: 'name',
    direction: 'asc',
  },
]

export const COLLECTION_SORT_OPTIONS = [
  {
    name: 'sort_recently_added',
    key: 'date_live',
    direction: 'desc',
  },
  {
    name: 'sort_last_updated',
    key: 'date_updated',
    direction: 'desc',
  },
  {
    name: 'sort_most_popular',
    key: 'followers_total',
    alias: 'stats.followers_total',
    direction: 'desc',
    default: true,
  },
  {
    name: 'sort_highest_rated',
    key: 'success_rating',
    alias: 'stats.ratings_weighted',
    direction: 'desc',
  },
  {
    name: 'sort_alphabetical',
    key: 'name',
    direction: 'asc',
  },
]

export const GUIDE_SORT_OPTIONS = [
  {
    name: 'sort_recently_added',
    key: 'date_live',
    direction: 'desc',
    default: true,
  },
  {
    name: 'views',
    key: 'visits_total',
    alias: 'stats.visits_total',
    direction: 'desc',
  },
  {
    name: 'sort_comments',
    key: 'comments_total',
    alias: 'stats.comments_total',
    direction: 'desc',
  },
  {
    name: 'sort_last_updated',
    key: 'date_updated',
    direction: 'desc',
  },
  {
    name: 'sort_alphabetical',
    key: 'name',
    direction: 'asc',
  },
]

export const LIBRARY_MODS_SORT_OPTIONS = [
  {
    name: 'name',
    key: 'name',
    direction: 'asc',
  },
  {
    name: 'filesize',
    key: 'modfile.filesize',
    direction: 'desc',
  },
  {
    name: 'added',
    key: 'date_live',
    direction: 'desc',
  },
  {
    name: 'updated',
    key: 'date_updated',
    direction: 'desc',
    default: true,
  },
  {
    name: 'downloads',
    key: 'downloads_total',
    alias: 'stats.downloads_total',
    direction: 'desc',
  },
  {
    name: 'subscribers',
    key: 'subscribers_total',
    alias: 'stats.subscribers_total',
    direction: 'desc',
  },
  {
    name: 'rating',
    key: 'ratings_total',
    alias: 'stats.ratings_total',
    direction: 'desc',
  },
]

export const CONTENT_MODS_SORT_OPTIONS = [
  {
    name: 'name',
    key: 'name',
    direction: 'asc',
  },
  {
    name: 'added',
    key: 'date_added',
    direction: 'desc',
    default: true,
  },
  {
    name: 'downloads',
    key: 'downloads_total',
    direction: 'desc',
  },
  {
    name: 'subscribers',
    key: 'subscribers_total',
    direction: 'desc',
  },
  {
    name: 'status',
    key: 'status',
    direction: 'desc',
  },
  {
    name: 'visibility',
    key: 'visible',
    direction: 'desc',
  },
  {
    name: 'role',
    key: 'level',
    direction: 'desc',
  },
]

export const LIBRARY_COLLECTION_SORT_OPTIONS = [
  {
    name: 'sort_recently_added',
    key: 'date_live',
    direction: 'desc',
  },
  {
    name: 'sort_last_updated',
    key: 'date_updated',
    direction: 'desc',
  },
  {
    name: 'sort_most_popular',
    key: 'followers_total',
    alias: 'stats.followers_total',
    direction: 'desc',
    default: true,
  },
  {
    name: 'ugc_count',
    key: 'stats.mods_total',
    direction: 'desc',
  },
  {
    name: 'sort_smallest_filesize',
    key: 'filesize',
    direction: 'asc',
  },
  {
    name: 'sort_alphabetical',
    key: 'name',
    direction: 'asc',
  },
]

export const COLLECTION_MODS_SORT_OPTIONS = [
  {
    name: 'date_updated',
    key: 'date_updated',
    direction: 'desc',
  },
  {
    name: 'sort_most_popular',
    key: 'downloads_total',
    alias: 'stats.downloads_total',
    direction: 'desc',
    default: true,
  },
  {
    name: 'sort_highest_rated',
    key: 'ratings_weighted_aggregate',
    alias: 'stats.ratings_weighted_aggregate',
    direction: 'desc',
  },
  {
    name: 'filesize',
    alias: 'modfile.filesize',
    key: 'filesize',
    direction: 'desc',
  },
  {
    name: 'sort_alphabetical',
    key: 'name',
    direction: 'asc',
  },
]
